export class GcpSqlVmSetup {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "setupPath",
            "baseName": "setupPath",
            "type": "GcpSqlVmSetupPath",
            "format": ""
        },
        {
            "name": "sqlServerRelease",
            "baseName": "sqlServerRelease",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceProjectId",
            "baseName": "sourceProjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "instanceName",
            "baseName": "instanceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "zone",
            "baseName": "zone",
            "type": "string",
            "format": ""
        },
        {
            "name": "backupBucket",
            "baseName": "backupBucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "backupPrefix",
            "baseName": "backupPrefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "serviceAccountName",
            "baseName": "serviceAccountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "scriptUrl",
            "baseName": "scriptUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "setupCommand",
            "baseName": "setupCommand",
            "type": "string",
            "format": ""
        },
        {
            "name": "keyCommands",
            "baseName": "keyCommands",
            "type": "string",
            "format": ""
        },
        {
            "name": "backupHealth",
            "baseName": "backupHealth",
            "type": "GcpSqlVmBackupHealth",
            "format": ""
        },
        {
            "name": "lastBackupArrivedAt",
            "baseName": "lastBackupArrivedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return GcpSqlVmSetup.attributeTypeMap;
    }
    constructor() {
    }
}
